// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'
import {SeqId} from './seq-id.js'

export class DeleteEntities {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): DeleteEntities {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsDeleteEntities(bb: flatbuffers.ByteBuffer, obj?: DeleteEntities): DeleteEntities {
    return (obj || new DeleteEntities()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsDeleteEntities(bb: flatbuffers.ByteBuffer, obj?: DeleteEntities): DeleteEntities {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new DeleteEntities()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  entityDeletes(index: number, obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 8, this.bb!) : null
  }

  entityDeletesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  entityUndeletes(index: number, obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new Id()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 8, this.bb!) : null
  }

  entityUndeletesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  pageDeletes(index: number, obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? (obj || new SeqId()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 12, this.bb!) : null
  }

  pageDeletesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  pageUndeletes(index: number, obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? (obj || new SeqId()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 12, this.bb!) : null
  }

  pageUndeletesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  static startDeleteEntities(builder: flatbuffers.Builder) {
    builder.startObject(4)
  }

  static addEntityDeletes(builder: flatbuffers.Builder, entityDeletesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, entityDeletesOffset, 0)
  }

  static startEntityDeletesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 4)
  }

  static addEntityUndeletes(builder: flatbuffers.Builder, entityUndeletesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, entityUndeletesOffset, 0)
  }

  static startEntityUndeletesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 4)
  }

  static addPageDeletes(builder: flatbuffers.Builder, pageDeletesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, pageDeletesOffset, 0)
  }

  static startPageDeletesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(12, numElems, 4)
  }

  static addPageUndeletes(builder: flatbuffers.Builder, pageUndeletesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, pageUndeletesOffset, 0)
  }

  static startPageUndeletesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(12, numElems, 4)
  }

  static endDeleteEntities(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }

  static createDeleteEntities(
    builder: flatbuffers.Builder,
    entityDeletesOffset: flatbuffers.Offset,
    entityUndeletesOffset: flatbuffers.Offset,
    pageDeletesOffset: flatbuffers.Offset,
    pageUndeletesOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    DeleteEntities.startDeleteEntities(builder)
    DeleteEntities.addEntityDeletes(builder, entityDeletesOffset)
    DeleteEntities.addEntityUndeletes(builder, entityUndeletesOffset)
    DeleteEntities.addPageDeletes(builder, pageDeletesOffset)
    DeleteEntities.addPageUndeletes(builder, pageUndeletesOffset)
    return DeleteEntities.endDeleteEntities(builder)
  }
}
